module.exports = __webpack_public_path__ + "img/angle-down.898f9944.svg";